var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Divider',{staticStyle:{"color":"#fff"},attrs:{"dashed":""}},[_vm._v("上刊设置汇总")]),_c('div',[_c('Table',{attrs:{"stripe":"","size":"small","data":_vm.list,"columns":_vm.tabelColumns}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }